<template>
  <div class="sd-card">
    <div ref="scroller" class="flex flex-col gap-3 p-4 overflow-y-auto" style="max-height: calc(100vh - 300px); min-height: 280px">
      <div class="text-center text-xs text-gray-400">{{ $t("securone.chat.started_by", { name: event.raisedByName, time: clock(event.raisedAt || event.createdAt) }) }}</div>
      <template v-for="m in messages">
        <div v-if="m.kind === 'system'" :key="m._id" class="text-center text-xs text-gray-400">{{ m.body }} · <span class="font-mono">{{ clock(m.createdAt) }}</span></div>
        <div v-else :key="m._id" class="flex gap-3" :class="{ 'flex-row-reverse': isMe(m) }">
          <SoAvatar :name="m.senderName" size="sm" :muted="!isMe(m)" />
          <div :class="{ 'text-right': isMe(m) }" style="max-width: 70%">
            <div class="text-xxs text-gray-400 mb-1">{{ m.senderName }}<span v-if="isMe(m)"> ({{ $t("securone.common.you") }})</span> · <span class="font-mono">{{ clock(m.createdAt) }}</span></div>
            <div v-if="m.body" class="inline-block rounded border px-3 py-2 text-sm text-left leading-relaxed" :class="isMe(m) ? 'bg-secondary-50 border-primary-200 text-gray-800' : 'bg-gray-50 border-secondary-200 text-gray-800'" style="max-width: 60ch">{{ m.body }}</div>
            <ChatAttachment v-if="m.attachment && m.attachment.s3Key" :eventId="String(event._id)" :messageId="String(m._id)" :attachment="m.attachment" :class="{ 'flex justify-end': isMe(m) }" />
          </div>
        </div>
      </template>
      <div v-if="event.status === 'resolved'" class="text-center text-xs text-gray-400">{{ $t("securone.chat.resolved_by", { name: event.resolvedByName, time: clock(event.resolvedAt) }) }}<template v-if="event.resolvedWithCode"> · {{ $t("securone.chat.code_used") }}</template></div>
    </div>
    <div class="border-t border-secondary-200 px-4 py-3">
      <form v-if="!readOnly" class="flex flex-col gap-2" @submit.prevent="send">
        <div v-if="file" class="flex items-center gap-3 rounded border border-secondary-200 bg-secondary-50 px-3 py-2 text-xs text-secondary-700">
          <img v-if="preview" :src="preview" class="h-12 w-12 rounded object-cover border border-secondary-200" alt="" />
          <span class="flex-1 truncate">{{ file.name }}</span>
          <button type="button" class="text-secondary-500 hover:text-red-600" :title="$t('securone.common.cancel')" @click="clearFile"><BaseIcon icon="times" /></button>
        </div>
        <div class="flex gap-2">
          <label class="sd-btn sd-btn--secondary cursor-pointer" :title="$t('securone.chat.attach')">
            <BaseIcon icon="camera" />
            <input type="file" class="hidden" accept="image/png,image/jpeg,image/webp,image/gif,image/heic,image/heif" @change="onFile" />
          </label>
          <input v-model="draft" type="text" :placeholder="$t('securone.chat.placeholder')" autocomplete="off" maxlength="2000" class="flex-1 bg-white border border-secondary-300 rounded text-sm text-gray-900 focus:outline-none focus:border-securdia-blue px-3 py-2" />
          <button type="submit" class="sd-btn sd-btn--primary" :disabled="(!draft.trim() && !file) || sending">{{ sending ? $t("securone.chat.sending") : $t("securone.chat.send") }}</button>
        </div>
      </form>
      <div v-else class="text-xs text-gray-500">{{ $t("securone.chat.read_only") }}</div>
    </div>
  </div>
</template>

<script>
import SoAvatar from "./SoAvatar.vue";
import ChatAttachment from "./ChatAttachment.vue";
import { clock } from "../securone.helpers";

// Event chat: text and photos, the same records the phones write. Emits
// `send` with { text, file } - the parent posts it.
export default {
  name: "EventChat",
  components: { SoAvatar, ChatAttachment },
  props: {
    event: { type: Object, required: true },
    messages: { type: Array, default: () => [] },
    meId: { type: String, default: "" },
    readOnly: { type: Boolean, default: true },
    sending: { type: Boolean, default: false },
  },
  data() {
    return { draft: "", file: null, preview: null };
  },
  methods: {
    clock,
    isMe(m) {
      return m.senderId && String(m.senderId) === String(this.meId);
    },
    onFile(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = "";
      if (!file) return;
      this.clearFile();
      this.file = file;
      try {
        this.preview = URL.createObjectURL(file);
      } catch (err) {
        this.preview = null;
      }
    },
    clearFile() {
      if (this.preview) URL.revokeObjectURL(this.preview);
      this.file = null;
      this.preview = null;
    },
    send() {
      const text = this.draft.trim();
      if (!text && !this.file) return;
      this.$emit("send", { text, file: this.file });
      this.draft = "";
      this.clearFile();
    },
    scrollToEnd() {
      this.$nextTick(() => {
        const el = this.$refs.scroller;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
  },
  watch: {
    "messages.length"() {
      this.scrollToEnd();
    },
  },
  mounted() {
    this.scrollToEnd();
  },
  beforeDestroy() {
    this.clearFile();
  },
};
</script>
